module.exports = __webpack_public_path__ + "static/viread-illustrations-2-2e56b4ce5f087ed9dae2f26985b31f17.jpg";